import { render, staticRenderFns } from "./PopupEditarPrazo.vue?vue&type=template&id=5fdce258&scoped=true&"
import script from "./PopupEditarPrazo.vue?vue&type=script&lang=js&"
export * from "./PopupEditarPrazo.vue?vue&type=script&lang=js&"
import style0 from "./popup_editar_prazo_global.scss?vue&type=style&index=0&lang=scss&"
import style1 from "./popup_editar_prazo.scss?vue&type=style&index=1&id=5fdce258&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdce258",
  null
  
)

export default component.exports